import type { ReactNode } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { contactsMetiersService } from "services";
import { useSnackbarErrorHandler } from "utils/errorHandling";
import { ActionType, useContactMetierActions } from "providers";
import DeleteIcon from "@mui/icons-material/Delete";
import { enqueueSnackbar } from "notistack";
import { ToastMessages } from "enums";
import { ContactMetierResume } from "components/ContactMetierResume";

export function DeleteContactMetierDialog(): ReactNode {
  const { actionType, closeActionDialog, targetContactMetier, isActionDialogOpen, onDelete } =
    useContactMetierActions();
  const { catchErrors, isLoading } = useSnackbarErrorHandler();

  if (targetContactMetier == null) {
    return;
  }

  function confirm(): void {
    async function confirmAndClose(): Promise<void> {
      if (targetContactMetier == null) {
        return;
      }
      await contactsMetiersService.deleteById(targetContactMetier.id);
      closeActionDialog();
      enqueueSnackbar({
        variant: "success",
        autoHideDuration: 2000,
        preventDuplicate: false,
        message: ToastMessages.CONTACT_METIER_DELETE_SUCCESS,
      });
      await onDelete?.(targetContactMetier);
    }
    void catchErrors(confirmAndClose);
  }

  return (
    <Dialog
      open={isActionDialogOpen && actionType === ActionType.DELETE}
      onClose={closeActionDialog}>
      <DialogTitle>Êtes-vous sûr de vouloir supprimer ce Contact Métier ?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ span: { fontWeight: "600" } }}>
          Attention! Cette opération est <span>irréversible</span>.
        </DialogContentText>
        <br />
        <DialogContentText>
          <ContactMetierResume contactMetier={targetContactMetier} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeActionDialog} color="error">
          Annuler
        </Button>
        <Button
          onClick={confirm}
          variant="contained"
          autoFocus
          loading={isLoading}
          loadingPosition="start"
          startIcon={<DeleteIcon />}>
          Oui, supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
}
